import { PaxSessionId } from "models/session/pax-session";
import { MultiPaxSessionId } from "models/session/session";

export class ItemLevelNavigationError extends Error {
  override name = "IncorrectNavigationError" as const;
  constructor(
    public sessionId: MultiPaxSessionId,
    public paxSessionId: PaxSessionId | undefined,
    msg?: string
  ) {
    super(msg);
  }
}
